import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import maxSize from 'popper-max-size-modifier';
import { useToken } from '@rexlabs/styling';
import { TransitionSingle } from '@rexlabs/animation';
import { Tether } from '@rexlabs/tether';
import { PrimaryIconButton } from '@rexlabs/button';
import { Menu } from '../menu';
import { DefaultCloseButton } from '../menu/close-button';
import { ActionMenuContent } from '../content';
var ITEM_HEIGHT = '4.4rem';

function getPlacementAnimation(placement) {
  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'top')) {
    return {
      from: {
        marginBottom: -5
      },
      enter: {
        marginBottom: 0
      },
      leave: {
        marginBottom: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'right')) {
    return {
      from: {
        marginLeft: -5
      },
      enter: {
        marginLeft: 0
      },
      leave: {
        marginLeft: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'bottom')) {
    return {
      from: {
        marginTop: -5
      },
      enter: {
        marginTop: 0
      },
      leave: {
        marginTop: -5
      }
    };
  }

  if (placement !== null && placement !== void 0 && _includesInstanceProperty(placement).call(placement, 'left')) {
    return {
      from: {
        marginRight: -5
      },
      enter: {
        marginRight: 0
      },
      leave: {
        marginRight: -5
      }
    };
  }

  return {};
}

export function FloatingActionMenu(_ref) {
  var items = _ref.items,
      subItems = _ref.subItems,
      title = _ref.title,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      _ref$placement = _ref.placement,
      propPlacement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      _ref$portalTarget = _ref.portalTarget,
      portalTarget = _ref$portalTarget === void 0 ? window.document.body : _ref$portalTarget,
      handleClose = _ref.handleClose,
      Icon = _ref.Icon,
      _ref$Button = _ref.Button,
      Button = _ref$Button === void 0 ? PrimaryIconButton : _ref$Button,
      TitleIcon = _ref.TitleIcon,
      _ref$CloseButton = _ref.CloseButton,
      CloseButton = _ref$CloseButton === void 0 ? DefaultCloseButton : _ref$CloseButton,
      isOpen = _ref.isOpen,
      selectedItem = _ref.selectedItem,
      highlightedIndex = _ref.highlightedIndex,
      selectItem = _ref.selectItem,
      getItemProps = _ref.getItemProps,
      getMenuProps = _ref.getMenuProps,
      getToggleButtonProps = _ref.getToggleButtonProps,
      onKeyDown = _ref.onKeyDown;
  var token = useToken();
  var menuMinHeight = token('actionMenu.menu.minHeight', '15rem');
  var menuMaxHeight = token('actionMenu.menu.maxHeight', // The default max height should allow for showing
  // half of an item to indicate the user can scroll
  // N.B. this will not work perfectly for custom items
  "calc(".concat(ITEM_HEIGHT, " * 6.5"));
  var applyMaxSize = useMemo(function () {
    return {
      name: 'applyMaxSize',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['maxSize'],
      fn: function fn(_ref2) {
        var _context, _context2;

        var state = _ref2.state;
        var height = state.modifiersData.maxSize.height;
        state.styles.popper.maxHeight = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "clamp(".concat(menuMinHeight, ", ")).call(_context2, height, "px, ")).call(_context, menuMaxHeight, ")");
      }
    };
  }, [menuMinHeight, menuMaxHeight]);
  return /*#__PURE__*/React.createElement(Tether, {
    distance: 4,
    placement: propPlacement,
    modifiers: [_objectSpread(_objectSpread({}, maxSize), {}, {
      options: {
        padding: 12
      }
    }), applyMaxSize]
  }, function (_ref3) {
    var placement = _ref3.placement,
        referenceProps = _ref3.referenceProps,
        popperProps = _ref3.popperProps;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, getToggleButtonProps(_objectSpread({}, referenceProps)), {
      role: "menubutton",
      tabIndex: 0,
      onKeyDown: onKeyDown,
      Icon: Icon
    })), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(TransitionSingle, {
      show: isOpen,
      configs: ['fade', getPlacementAnimation(placement), {
        config: {
          mass: 1,
          tension: 320,
          friction: 26
        }
      }]
    }, /*#__PURE__*/React.createElement(Menu, _extends({}, getMenuProps(popperProps, {
      suppressRefError: true
    }), {
      title: title,
      minWidth: minWidth,
      maxWidth: maxWidth,
      selectedItem: selectedItem,
      handleClose: handleClose,
      selectItem: selectItem,
      TitleIcon: TitleIcon,
      CloseButton: CloseButton
    }), /*#__PURE__*/React.createElement(ActionMenuContent, {
      items: subItems !== null && subItems !== void 0 ? subItems : items,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps
    }))), portalTarget));
  });
}